import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import caTranslation from './locales/ca/translation.json';
import esTranslation from './locales/es/translation.json';
import enTranslation from './locales/en/translation.json';

export const SUPPORTED_LANGUAGES = ['ca', 'es', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'taskfly-language';

const resources = {
  ca: { translation: caTranslation },
  es: { translation: esTranslation },
  en: { translation: enTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'] as string[],
      lookupLocalStorage: STORAGE_KEY,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng: string) => {
  if (SUPPORTED_LANGUAGES.includes(lng as SupportedLanguage)) {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
